import React from 'react';
import { motion } from 'framer-motion';

const CONTAINER_INITIAL = { opacity: 0, y: 30 };
const CONTAINER_VISIBLE = { opacity: 1, y: 0 };
const CONTAINER_TRANSITION = { duration: 0.6 };

const BADGE_INITIAL = { opacity: 0, scale: 0.8 };
const BADGE_VISIBLE = { opacity: 1, scale: 1 };
const BADGE_TRANSITION = { duration: 0.5 };

const BrandsHeader = ({ isInView, t }) => {
  return (
    <motion.div
      initial={CONTAINER_INITIAL}
      animate={isInView ? CONTAINER_VISIBLE : CONTAINER_INITIAL}
      transition={CONTAINER_TRANSITION}
      className="text-center mb-6 md:mb-16"
    >
      <motion.div
        initial={BADGE_INITIAL}
        animate={isInView ? BADGE_VISIBLE : BADGE_INITIAL}
        transition={BADGE_TRANSITION}
        className="inline-block px-3 md:px-4 py-1 md:py-2 rounded-full bg-gradient-to-r from-orange-500/20 to-blue-500/20 border border-orange-500/30 mb-3 md:mb-6"
      >
        <span className="text-orange-400 font-semibold text-xs md:text-sm">
          {t.brands.badge}
        </span>
      </motion.div>

      <h2 className="text-2xl md:text-4xl lg:text-5xl xl:text-6xl font-bold mb-3 md:mb-6">
        <span className="bg-gradient-to-r from-white via-blue-100 to-white bg-clip-text text-transparent">
          {t.brands.title}
        </span>
      </h2>
      <p className="text-gray-400 text-sm md:text-lg max-w-2xl mx-auto px-4">
        {t.brands.subtitle}
      </p>
    </motion.div>
  );
};

export default BrandsHeader;
